export default function SEO(){
    return(
        <div>
            <div className="text-center">SEO Manager</div>
        </div>
    )
}